var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63.4 63.4",
    style: {
      enableBackground: "new 0 0 63.4 63.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F15A2C;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 31.7,
    cy: 31.7,
    r: 31.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 31.7,
    cy: 31.7,
    r: 24.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,44.2c3.8,0,7.4,0,10.9,0c0.3,0,0.9-0.3,1-0.6c1.4-3.5,2.7-7.1,4.1-10.9c-2.1,0-3.9,0-6,0 c1.6-4.6,3.2-9,4.7-13.4c-0.1,0-0.2-0.1-0.2-0.1c-4.5,5.8-9,11.5-13.6,17.5c1.1,0.1,1.9,0.2,2.9,0.3c-0.7,1.3-1.3,2.4-1.9,3.5 C25.1,41.6,24.4,42.8,23.7,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,44.2c0.8-1.4,1.4-2.6,2-3.7c0.6-1.1,1.2-2.2,1.9-3.5c-1-0.1-1.8-0.2-2.9-0.3c4.6-6,9.1-11.7,13.6-17.5 c0.1,0,0.2,0.1,0.2,0.1c-1.5,4.4-3.1,8.8-4.7,13.4c2.1,0,3.9,0,6,0c-1.4,3.8-2.8,7.3-4.1,10.9c-0.1,0.3-0.7,0.6-1,0.6 C31,44.2,27.5,44.2,23.7,44.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.b3972d5c84054b93c8266bb205397f5d.svg";
export { ForwardRef as ReactComponent };